import { Card, Grid, Table, TableBody, TableContainer } from "@mui/material";
import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { useForm } from "react-hook-form";
import { API_URLS, ResDataType } from "src/api/apiUrls";
import useApiServices from "src/api/useApiServices";
import AppLoadingAndErrorWrapper from "src/components/common/AppLoadingAndErrorWrapper";
import FormProvider from "src/components/hook-form/form-provider";
import Scrollbar from "src/components/scrollbar";
import {
  TableHeadCustom,
  TablePaginationCustom,
  TableSkeleton,
  useTable
} from "src/components/table";
import { useBoolean } from "src/hooks/use-boolean";
import AdminsTableRow from "src/sections/roles-and-permissions/admins/AdminsTableRow";

export default function AdminsPage () {
  const table = useTable({ defaultRowsPerPage: 10 });
  const quickDetails = useBoolean();
  const { useGetListApi, useDeleteApi } = useApiServices();

  const methods = useForm({
    defaultValues: {},
  });

  const [search, setSearch] = useState({});

  const { data, isLoading, error } = useGetListApi<ResDataType["admins"]>({
    url: API_URLS.ADMINS,
    parameters: {
      page: table.page,
      pageSize: table.rowsPerPage,
    },
  });

  const { mutate: deleteAdmin, isLoading: isDeleting } = useDeleteApi({
    url: API_URLS.ADMINS,
  });

  const TABLE_HEAD = [
    { id: "1", label: "Role ID" },
    { id: "2", label: "Role name" },
    { id: "3", label: "User name" },
    { id: "4", label: "Status" },
    { id: "5", label: "Last activity" },
    { id: "6", label: "Actions" },
  ];

  return (
    <>
      <Helmet>
        <title>Admins</title>
      </Helmet>
      <AppLoadingAndErrorWrapper isLoading={isLoading} errorMessage={error}>
        <FormProvider methods={methods}>
          <Grid container spacing={4} my={1}>
            <>
              <Grid item xs={12}>
                <Card>
                  <TableContainer>
                    <Scrollbar>
                      <Table>
                        <TableHeadCustom headLabel={TABLE_HEAD} />
                        <TableBody>
                          {isLoading ? (
                            [...Array(table.rowsPerPage)].map((i, index) => (
                              <TableSkeleton key={index} sx={{ height: 80 }} />
                            ))
                          ) : (
                            <>
                              {data!?.items?.map(row => (
                                <AdminsTableRow
                                  key={row.id}
                                  row={row}
                                />
                              ))}
                            </>
                          )}
                        </TableBody>
                      </Table>
                    </Scrollbar>
                  </TableContainer>
                  {data && (
                    <TablePaginationCustom
                      count={data?.totalItems}
                      page={data ? +data.currentPage - 1 : 1}
                      rowsPerPage={table.rowsPerPage}
                      onPageChange={table?.onChangePage}
                      onRowsPerPageChange={table?.onChangeRowsPerPage}
                    />
                  )}
                </Card>
              </Grid>
            </>
          </Grid>
        </FormProvider>
      </AppLoadingAndErrorWrapper>
    </>
  );
}
